var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"is-size-7 has-text-weight-light"},[_vm._v(" "+_vm._s(_vm.getDate(_vm.event.date))+" ")]),_c('p',{staticClass:"title is-size-5 has-text-dark"},[_vm._v("Registered owner change")])])
}
var staticRenderFns = []

export { render, staticRenderFns }